module.exports = __webpack_public_path__ + "img/index-1.7523aa12.png";